// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { AnyAction } from "@insite/client-framework/Store/Reducers";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { getProductCollectionV1 } from "@stoneage/App/Services/ProductServiceV1/ProductServiceV1";
import { CustomAppState } from "@stoneage/App/Store/Reducers";
import { setUrlsToQuickLookupProducts } from "@stoneage/App/Widgets/QuickProductLookup/QuickProductLookupHelpers";

type Parameter = {
    page?: number;
    pageSize?: number;
};

type HandlerType = Handler<Parameter, {}>;

export const ChangePaginationParameters: HandlerType = async props => {
    const { page, pageSize } = props.parameter;
    const customAppState = props.getState() as CustomAppState;
    const products = customAppState.xProductLookup.filteredProducts;
    let pagination = customAppState.xProductLookup.pagination;
    if (products) {
        pagination = {
            ...pagination,
            currentPage: pageSize ? 1 : page || pagination.page,
            page: pageSize ? 1 : page || pagination.page,
            pageSize: pageSize || pagination.pageSize,
            numberOfPages: Math.ceil(products.length / (pageSize || pagination.pageSize)),
        };

        const startingIndex = pagination.page > 1 ? (pageSize || pagination.pageSize) * (pagination.page - 1) : 0;
        const _paginatedProducts = products.slice(startingIndex, startingIndex + (pageSize || pagination.pageSize));
        const productNumbers = _paginatedProducts
            .filter(product => !product.urlIsSet)
            .map(product => product.productNumber);
        let paginatedProducts = [..._paginatedProducts];

        if (productNumbers) {
            try {
                const { products } = await getProductCollectionV1({ erpNumbers: productNumbers });
                paginatedProducts = setUrlsToQuickLookupProducts(products, _paginatedProducts);
            } catch (error: any) {
                /* empty */
            }
        }
        props.dispatch({
            type: "Pages/ProductLookup/SetPaginatedProducts",
            paginatedProducts,
            pagination,
        } as unknown as AnyAction);
    }
};

export const chain = [ChangePaginationParameters];

const paginationChangeHandler = createHandlerChainRunner(chain, "PaginationChangeHandler");
export default paginationChangeHandler;
